import { useLayoutEffect } from "react";
import Lenis from "@studio-freight/lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const useLenis = (duration: number = 1, disabled: boolean = false): void => {
  useLayoutEffect(() => {
    if (typeof window === "undefined" || disabled) return;

    const lenis = new Lenis({
      duration,
      smoothWheel: true,
      easing: (t) => 1 - Math.pow(1 - t, 3),
    });

    const raf = (time: number) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    lenis.on("scroll", ScrollTrigger.update);

    const refreshScroll = () => {
      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 100);
    };

    if (document.readyState === "complete") {
      refreshScroll();
    } else {
      window.addEventListener("load", refreshScroll);
    }
    window.addEventListener("resize", refreshScroll);

    return () => {
      lenis.off("scroll", ScrollTrigger.update);
      lenis.destroy();
      window.removeEventListener("load", refreshScroll);
      window.removeEventListener("resize", refreshScroll);
    };
  }, [duration, disabled]);
};
